import qs from 'query-string';

import {
  ALL_POSSIBLE_QUERY_COLLECTION,
  ALL_POSSIBLE_QUERY_KEYS,
  FILTER_CONFIG_DURATION,
  FILTER_CONFIG_TIME,
  QUERY_DURATION_KEY,
  QUERY_LANGUAGE_KEY,
  QUERY_SEARCH_KEY,
  QUERY_TIME_KEY,
  QUERY_VIDEO_START_PLAY_KEY,
  SEARCH_QUERY_KEYS,
} from '../../common/constants/queryParams';

const validAndNotDefault = (validList, defaultValue, value) =>
  value !== defaultValue && validList.some((item) => item.value === value);

export const getValidQuery = (queryObject) => {
  const queriesValidation = {
    [QUERY_LANGUAGE_KEY]: (inputValue) => {
      const isValid = inputValue !== ALL_POSSIBLE_QUERY_COLLECTION[QUERY_LANGUAGE_KEY];

      return {
        isValid,
        value: isValid ? inputValue : null,
      };
    },
    [QUERY_TIME_KEY]: (inputValue) => {
      const isValid = validAndNotDefault(FILTER_CONFIG_TIME, ALL_POSSIBLE_QUERY_COLLECTION[QUERY_TIME_KEY], inputValue);

      return {
        isValid,
        value: isValid ? inputValue : null,
      };
    },
    [QUERY_DURATION_KEY]: (inputValue) => {
      const isValid = validAndNotDefault(
        FILTER_CONFIG_DURATION,
        ALL_POSSIBLE_QUERY_COLLECTION[QUERY_DURATION_KEY],
        inputValue,
      );

      return {
        isValid,
        value: isValid ? inputValue : null,
      };
    },
    [QUERY_SEARCH_KEY]: (inputValue) => {
      const value = inputValue?.trim() ?? null;

      return {
        isValid: !!value,
        value,
      };
    },
    [QUERY_VIDEO_START_PLAY_KEY]: (inputValue) => {
      const time = parseInt(inputValue, 10);
      const isValid = !Number.isNaN(time) && time > 0;

      return {
        isValid,
        value: time,
      };
    },
    otherQueries: (inputValue) => {
      const resultValue = inputValue?.trim() ?? null;

      return {
        isValid: !!resultValue,
        value: resultValue,
      };
    },
  };

  return Object.keys(queryObject).reduce((acc, key) => {
    const validationFn = queriesValidation[key] ?? queriesValidation.otherQueries;
    const rawValue = queryObject[key];

    const { isValid, value } = validationFn(rawValue);

    return isValid
      ? {
          ...acc,
          [key]: value,
        }
      : acc;
  }, {});
};

export const parseQueryObject = (searchString) => getValidQuery(qs.parse(searchString));

export const isEqualAllQueryObjects = (a, b) => !ALL_POSSIBLE_QUERY_KEYS.some((prop) => a[prop] !== b[prop]);

export const isEqualSearchQueryObjects = (a, b) => !SEARCH_QUERY_KEYS.some((prop) => a[prop] !== b[prop]);
